import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import TreeSelect from 'rc-tree-select';
import { isBeamUser } from '../Utils/HelperFunctions';
import { FORM_COMPONENTS, FORM_LABELS, BEAM_FORM_COMPONENTS, BEAM_FORM_LABELS } from '../Constants/Constants';

const ONBOARDING_KEYS = ['REGISTRATION_FORM', 'PRO_CONVERSION_FORM', 'ENTERPRISE_CONVERSION_FORM'];
const ACCOUNT_MANAGEMENT_KEYS = ['UPDATE_CONTRACT', 'BLOCK_USER', 'SOP_MANAGEMENT', 'DIY_ENTITLEMENT'];
const DATA_OPS_KEYS = ['USAGE_SUMMARY'];
const API_KEYS = ['API_KEY_MANAGER', 'ENTERPRISE_CALLBACK_MANAGER', 'THIRD_PARTY_CALLBACK_MANAGER'];

const getTreeSelectOptions = isBeam => {
  const formComponents = isBeam ? BEAM_FORM_COMPONENTS : FORM_COMPONENTS;
  const formLabels = isBeam ? BEAM_FORM_LABELS : FORM_LABELS;
  const availableKeys = Object.keys(formComponents);

  const createNode = key => ({
    key,
    value: key,
    title: formLabels[key]
  });

  const createGroupNode = (key, title, childKeys) => {
    const children = childKeys.filter(k => availableKeys.includes(k)).map(createNode);
    if (children.length === 0) return null;
    return {
      key,
      value: key,
      title,
      selectable: false,
      disabled: true,
      children
    };
  };

  const groupedKeys = [...ONBOARDING_KEYS, ...ACCOUNT_MANAGEMENT_KEYS, ...DATA_OPS_KEYS, ...API_KEYS];
  const ungroupedKeys = availableKeys.filter(key => !groupedKeys.includes(key));

  const nodes = [];

  // Add grouped categories
  const onboardingGroup = createGroupNode('onboarding', 'Onboarding', ONBOARDING_KEYS);
  if (onboardingGroup) nodes.push(onboardingGroup);

  const accountManagementGroup = createGroupNode('account_management', 'Account Management', ACCOUNT_MANAGEMENT_KEYS);
  if (accountManagementGroup) nodes.push(accountManagementGroup);

  const dataOpsGroup = createGroupNode('data_ops', 'Data & Ops', DATA_OPS_KEYS);
  if (dataOpsGroup) nodes.push(dataOpsGroup);

  const apiGroup = createGroupNode('api', 'Api', API_KEYS);
  if (apiGroup) nodes.push(apiGroup);

  // Add ungrouped items at root level
  ungroupedKeys.forEach(key => {
    nodes.push(createNode(key));
  });

  return nodes;
};

const FormSelector = ({ onChange }) => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(undefined);

  const treeData = useMemo(() => getTreeSelectOptions(isBeamUser()), []);

  const handleChange = value => {
    setSelectedValue(value);

    if (value) {
      if (FORM_LABELS[value] === FORM_LABELS.COPY_TRANSFER) {
        navigate('/copy-transfer');
      } else {
        onChange(value);
      }
    }
  };

  return (
    // <select
    //   className='form-select form-select-lg mb-3'
    //   aria-label='Default select example'
    //   onChange={e => {
    //     const LABELS = isBeamUser() ? BEAM_FORM_LABELS : FORM_LABELS;
    //     if (LABELS[e.target.value] === LABELS.COPY_TRANSFER) {
    //       navigate('/copy-transfer');
    //     } else onChange(e.target.value);
    //   }}>
    //   <option>Select Action</option>
    //   {isBeamUser()
    //     ? Object.keys(BEAM_FORM_COMPONENTS).map(key => (
    //         <option key={key} value={key}>
    //           {BEAM_FORM_LABELS[key]}
    //         </option>
    //       ))
    //     : Object.keys(FORM_COMPONENTS).map(key => (
    //         <option key={key} value={key}>
    //           {FORM_LABELS[key]}
    //         </option>
    //       ))}
    // </select>
    <TreeSelect
      value={selectedValue}
      treeData={treeData}
      onChange={handleChange}
      placeholder='Select Action'
      treeDefaultExpandAll
      allowClear
      listHeight={450}
    />
  );
};

export default FormSelector;
